import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import styled from 'styled-components';

import Layout from '../components/Layout'
import BlogRoll from '../components/BlogRoll'

const Headings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  h1 {
    background-color: #4e7263;
    padding: 20px;
  } 
  h3 {
    background-color: #4e7263;
    padding: 20px;
  }
`;

export const IndexPageTemplate = ({
  title,
  heading,
  subheading,
  mainpitch,
  description,
}) => (
  <div>
    <div>
      <Headings>
        <h1>
          {title}
        </h1>
        <h3>
          {subheading}
        </h3>
      </Headings>
    </div>
    <section>
      <div>
        <div>
          <div>
            <div>
              <div>
                <div>
                  <div>
                    <h1>{mainpitch.title}</h1>
                  </div>
                  <div>
                    <h3>{mainpitch.description}</h3>
                  </div>
                </div>                
                <div>
                  <h3>
                    Latest stories
                  </h3>
                  <BlogRoll />
                  <div>
                    <Link to="/blog">
                      Read more
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
)

IndexPageTemplate.propTypes = {
  title: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        title={frontmatter.title}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        heading
        subheading
        mainpitch {
          title
          description
        }     
      }
    }
  }
`
